import { createCrudActions } from '../utils/crudGenerator';

const formatEmailusers = (data) => {
    if (!data) {
        return [];
    }
    const formatItem = (item) => ({
        ...item,
        label: `${item.name}`,
        value: item._id,
    });

    if (Array.isArray(data)) {
        return data.map(formatItem);
    }
    return formatItem(data);
};

export const {
    fetch: fetchEmailusers,
    create: createEmailuser,
    update: updateEmailuser,
    delete: deleteEmailusers
} = createCrudActions('EMAILUSER', "Correo", formatEmailusers);